import React, { useEffect, useState } from "react";
import moment from "moment-jalaali";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { TextInput, DateInput } from "ui";

import { useMerchant } from "features/account/api/merchant";
import { useAppSelector } from "store";
import { accountSchema, AccountFormFields } from "../schema";

import styles from "./account.module.scss";

export const Form = () => {
  const userId = useAppSelector((state) => state.dashboard.userId);
  const [isEditable, setIsEditable] = useState(false);
  const { data, isFetched } = useMerchant({
    id: userId,
  });
  const form = useForm<AccountFormFields>({
    defaultValues: {},
    resolver: zodResolver(accountSchema),
  });
  const { control, register, reset } = form;
  useEffect(() => {
    if (data && isFetched) {
      const user = data.data;
      reset({
        national_id: user.nationalCode,
        full_name: user.firstNameFa + " " + user.lastNameFa,
        email: user.email,
        sign_up_date: moment(user.createdOn, "jYYYY/jM/jD"),
        phone_number: user.phoneNumber,
        // postal_code: user.postalCode,
        // address: user.address,
        // website: user.websiteAddress,
        // website_description: user.websiteDescription,
        // birthday: moment(user.birthDate, "jYYYY/jM/jD"),
        // birth_location: user.birthPlace,
        // shaba_number: user.shaba,
      });
    }
  }, [data, isFetched, reset, userId]);

  return (
    <div className={styles.form_container}>
      <form>
        <Row>
          <Col md={3} sm={6}>
            <TextInput
              disabled={!isEditable}
              registration={register("full_name")}
              placeholder={"نام و نام خانوادگی خود را وارد کنید"}
              label={"نام و نام خانوادگی"}
            />
          </Col>
          <Col md={3} sm={6}>
            <TextInput
              disabled={!isEditable}
              registration={register("phone_number")}
              placeholder={"شماره تلفن همراه خود را وارد کنید"}
              label={"تلفن همراه"}
            />
          </Col>
          <Col md={3} sm={6}>
            <TextInput
              disabled={!isEditable}
              registration={register("email")}
              placeholder={"ایمیل خود راوارد کنید"}
              label={"ایمیل"}
            />
          </Col>
        </Row>

        <Row>
          <Col md={3} sm={6}>
            <DateInput
              isDisabled={!isEditable}
              controller={control}
              name={"birthday"}
              placeholder={"تاریخ تولد خود را وارد کنید"}
              label={"تاریخ تولد"}
            />
          </Col>
          <Col md={3} sm={6}>
            <TextInput
              disabled={!isEditable}
              registration={register("national_id")}
              placeholder={"کد ملی خود را وارد کنید"}
              label={"کد ملی"}
            />
          </Col>
        </Row>
      </form>
      {/* <div className="d-flex align-items-end justify-content-end mt-5">
        <Row>
          <Col>
            <Button
              size="lg"
              variant="info_outline"
              type="button"
              onClick={() => setIsEditable(!isEditable)}
            >
              {isEditable ? "ذخیره" : "ویرایش"}
            </Button>
          </Col>
        </Row>
      </div> */}
    </div>
  );
};
